/**
 * 转念 hub 首页（/decide/）：决策单搜索 + 常用词
 *
 * 定位：与台账首页 hub.js 同款交互（结构约定刻意保持一致，便于三站对照维护），
 *      也不需要收藏 / 最近使用，所以单独一个迷你脚本，
 *      不引入 tools/ui.min.js（那份还带日期面板、拖拽上传等转念用不上的组件）。
 *
 * 结构约定（模板 app/decide/view/index/home.html）：
 *   [data-hub-search]                  搜索输入框
 *   [data-hub-clear]                   输入框内的清空按钮（有内容才显示 is-show）
 *   [data-hub-hot]                     常用词按钮（Hero 与空状态各一组，都是「填词并筛选」）
 *   [data-hub-reset]                   空状态里的复位按钮
 *   .dz-hub-card[data-search]          决策单卡片，data-search 是服务端拼好的可搜索文本
 *   [data-hub-group]                   场景分组容器（组标题 + 组内卡片；2026-09-24 起有分组，
 *                                      组内全部命不中时整组隐藏——口径同台账 hub.js）
 *   [data-hub-empty]                   空状态
 *
 * 三条纪律（与 tools/js/ui.js / 台账 hub.js 一致）：
 *   ① 同状态零 DOM 写入：className 先比对再写，避免每次输入触发全量样式重算；
 *   ② 同步渲染：不做 rAF 合帧 —— 输入事件本身稀疏，合帧只会让「派发 input 后立即读 DOM」
 *      的外部调用（冒烟规格、热词点击）拿到旧状态；
 *   ③ 纯前端零请求：卡片是 SEO 内容，只加 / 去 is-hidden 类，节点始终留在 DOM 里。
 */
(function (global) {
  'use strict';

  var doc = global.document;

  function ready(fn) {
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function isHidden(el) {
    return /(^|\s)is-hidden(\s|$)/.test(el.className);
  }

  ready(function () {
    var input = doc.querySelector('[data-hub-search]');
    var cards = [].slice.call(doc.querySelectorAll('.dz-hub-card[data-search]'));
    if (!input || !cards.length) return;

    var empty = doc.querySelector('[data-hub-empty]');
    var clearBtn = doc.querySelector('[data-hub-clear]');
    var resetBtn = doc.querySelector('[data-hub-reset]');
    var hots = [].slice.call(doc.querySelectorAll('[data-hub-hot]'));
    // 场景分组（2026-09-24）：组内全部命不中时整组隐藏（连同组标题），口径同台账 hub.js
    var groups = [].slice.call(doc.querySelectorAll('[data-hub-group]'));
    var kw = '';

    function render() {
      var visible = 0;
      cards.forEach(function (card) {
        var ok = !kw || (card.getAttribute('data-search') || '').indexOf(kw) > -1;
        if (ok) visible++;
        if (ok === !isHidden(card)) return;          // 期望状态 == 当前状态 → 一个字都不写
        card.className = ok
          ? card.className.replace(/\s*is-hidden/g, '')
          : card.className + ' is-hidden';
      });

      // 分组显隐：组内一张都不剩就整组隐藏（hidden 属性，浏览器默认 display:none）
      groups.forEach(function (g) {
        var has = [].some.call(g.querySelectorAll('.dz-hub-card'), function (c) {
          return !isHidden(c);
        });
        if (g.hidden !== !has) g.hidden = !has;      // 同状态零写入
      });

      if (empty) {
        if (visible) { empty.classList.remove('is-show'); }
        else { empty.classList.add('is-show'); }
      }
      if (clearBtn) {
        if (kw) { clearBtn.classList.add('is-show'); }
        else { clearBtn.classList.remove('is-show'); }
      }
    }

    /** 滚到第一个命中的分组（组标题先行入镜；点常用词后才有必要，输入时不打扰） */
    function scrollToFirstHit() {
      var first = doc.querySelector('.dz-hub-card:not(.is-hidden)');
      var group = first && first.closest ? first.closest('[data-hub-group]') : null;
      var target = group || first;
      if (target && typeof target.scrollIntoView === 'function') {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    /** 把关键词写进输入框并即时筛选（空词 = 复位） */
    function apply(word) {
      kw = String(word || '').trim().toLowerCase();
      input.value = word || '';
      render();
      if (kw) scrollToFirstHit();
    }

    input.addEventListener('input', function () {
      kw = String(input.value || '').trim().toLowerCase();
      render();
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { apply(''); input.blur(); return; }
      // 回车直达：命中唯一时直接进那张决策单；多个匹配不动作，避免误跳
      if (e.key === 'Enter' && !e.isComposing) {
        var hit = cards.filter(function (c) { return !isHidden(c); });
        if (hit.length === 1) {
          // href 缺失就无操作（原「|| ''」会把空串赋给 location.href = 整页重载）
          var href = hit[0].getAttribute('href');
          if (href) { e.preventDefault(); global.location.href = href; }
        }
      }
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function () { apply(''); input.focus(); });
    }
    if (resetBtn) {
      resetBtn.addEventListener('click', function () { apply(''); input.focus(); });
    }

    // 常用词：首屏就能点走，省去打字（空状态里的那组同样生效）
    hots.forEach(function (btn) {
      btn.addEventListener('click', function () {
        apply(btn.getAttribute('data-hub-hot') || '');
        input.focus();
      });
    });

    // 键盘惯例：按 / 聚焦搜索框（已在输入态时不拦截，否则打不出斜杠）
    doc.addEventListener('keydown', function (e) {
      if (e.key !== '/' || e.ctrlKey || e.metaKey || e.altKey) return;
      var el = doc.activeElement;
      var tag = el ? String(el.tagName || '').toLowerCase() : '';
      if (tag === 'input' || tag === 'textarea' || tag === 'select' || (el && el.isContentEditable)) return;
      e.preventDefault();
      input.focus();
    });
  });
})(window);
